import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styled } from "@mui/material";
import { UserListContaier } from "../../containers/UserListContaier";
import { Home } from "../Home";
import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { USER_GROUPS } from "constants/roles";
import { ManagementType } from "types/common";
import { useEffect } from "react";
import { CircularProgress } from "@material-ui/core";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pr: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const StyledTab = styled(Tab)({
  "&.MuiButtonBase-root": {
    backgroundColor: "#F0F0F0",
    textTransform: "none",
    borderRadius: 10,
    fontSize: 14,
    margin: 10,
    padding: 10,
    fontWeight: "400",
  },
  "&.Mui-selected": {
    color: "white",
    backgroundColor: "#161728",
    textTransform: "none",
    borderRadius: 10,
    fontSize: 14,
    padding: 10,
    margin: 10,
    fontWeight: "400",
  },
});

export const ClinicManagementHome = () => {
  const currentClinician: any = useAppSelector(selectCurrentClinician);
  const [currentUserRoles] = React.useState(currentClinician?.role);
  const [value, setValue] = React.useState(-1);
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    switch (currentUserRoles?.length > 0) {
      case currentUserRoles.includes(USER_GROUPS.CLINIC_ADMIN):
        setValue(0);
        return;
      case currentUserRoles.includes(USER_GROUPS.CLINIC_ASSISTANT):
        setValue(2);
        return;
      case currentUserRoles.includes(USER_GROUPS.CLINIC_TEAM_LEAD):
        setValue(2);
        return;
      case currentUserRoles.includes(USER_GROUPS.CLINIC_TEAM_MEMBER):
      case currentUserRoles.includes(USER_GROUPS.CLINICIAN):
        setValue(4);
        return;
      default:
        setValue(0);
        return;
    }
  }, [currentUserRoles]);

  return value == -1 ? (
    <CircularProgress color="inherit" size={15} />
  ) : (
    <Box sx={{ width: "100%", marginTop: 4 }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
        >
          <StyledTab
            disabled={!currentUserRoles.includes(USER_GROUPS.CLINIC_ADMIN)}
            label="My Clinic"
          />
          <StyledTab
            disabled={!currentUserRoles.includes(USER_GROUPS.CLINIC_ADMIN)}
            label="User Management"
          />
          <StyledTab
            disabled={
              !currentUserRoles.includes(USER_GROUPS.CLINIC_ASSISTANT) &&
              !currentUserRoles.includes(USER_GROUPS.CLINIC_TEAM_LEAD)
            }
            label="Patient Management"
          />
          <Box flex={1} />
          <StyledTab
            disabled={
              !currentUserRoles.includes(USER_GROUPS.CLINIC_TEAM_MEMBER) &&
              !currentUserRoles.includes(USER_GROUPS.CLINICIAN)
            }
            label="Patient Care"
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Home />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <UserListContaier managementType={ManagementType.USER} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UserListContaier managementType={ManagementType.PATIENT} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <UserListContaier managementType={ManagementType.PATIENT_CARE} />
      </TabPanel>
    </Box>
  );
};
